import { render } from "./EditAgency.vue?vue&type=template&id=b752153a"
import script from "./EditAgency.vue?vue&type=script&lang=js"
export * from "./EditAgency.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/html/webmobtuts/realestateapp/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__